export enum ImageType {
    ProfilePhoto = 1
}